<template>
  <div class="main">
    <div class="content">
      <div class="form-row-line">
        <div class="form-field">
          <popup-button button-text="Добавить правило начислений">
            <add-accrual-rules v-on:rules-add="getRules"> </add-accrual-rules>
          </popup-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_title">
        Список правил начислений
      </div>
      <div class="content_row col-4 bold">
        <div>Услуга</div>
        <div>Участок</div>
        <div>Дата начислений</div>
        <div>Сумма начислений</div>
      </div>
      <div
        class="content_row col-4"
        v-for="(rule, key) in accrualrules"
        :key="key"
      >
        <div>{{ services[rule.SERVICE]["NAME"] }}</div>
        <div>{{ rule.PLOT }}</div>
        <div>{{ rule.DATE }}</div>
        <div>{{ rule.SUM }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import addAccrualRules from "@/components/backoffice/documents/add/AccrualRules";

export default {
  name: "Services",
  components: {
    addAccrualRules
  },
  data() {
    return {
      url: config.backend_url,
      accrualrules: [],
      services: []
    };
  },
  computed: {},
  methods: {
    getRules: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "accrualrules/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            let reverseData = [];
            let reverseKey = Object.keys(data)
              .sort()
              .reverse();
            reverseKey.forEach(function(key) {
              reverseData.push(data[key]);
            });
            self.accrualrules = reverseData;
          }
        });
    },
    getServices: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    }
  },
  created() {
    this.getServices();
    this.getRules();
  }
};
</script>
